module.exports = __webpack_public_path__ + "public/Icons/mobile_app_settings.svg?cdab7ee7";